export const GLOBAL_SAVE_STALL = 'GLOBAL_SAVE_STALL';
export const GLOBAL_CHANGE_LAYOUT_COLLAPSED = 'GLOBAL_CHANGE_LAYOUT_COLLAPSED';
export const GLOBAL_CLEAR_NOTICES = 'GLOBAL_CLEAR_NOTICES';
export const GLOBAL_SAVE_NOTICES = 'GLOBAL_SAVE_NOTICES';
